import React, { forwardRef } from "react";
import * as S from "./style";
import { ButtonBaseProps } from "./interface";

const ButtonBase = forwardRef<HTMLButtonElement, ButtonBaseProps>(
  ({ type = "button", ...restProps }: ButtonBaseProps, ref) => {
    const icon = restProps.icon;

    return (
      <S.Button {...restProps} type={type}>
        {restProps.icon ? (
          <S.ButtonContentContainer iconPosition={restProps.iconPosition}>
            {icon ? icon : null}
            {restProps.children}
          </S.ButtonContentContainer>
        ) : (
          restProps.children
        )}
      </S.Button>
    );
  }
);

ButtonBase.displayName = "ButtonBase";

export default ButtonBase;
